import { render, staticRenderFns } from "./yuqing.vue?vue&type=template&id=dfdc6850&scoped=true"
import script from "./yuqing.vue?vue&type=script&lang=js"
export * from "./yuqing.vue?vue&type=script&lang=js"
import style0 from "./yuqing.vue?vue&type=style&index=0&id=dfdc6850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdc6850",
  null
  
)

export default component.exports